import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
export class UserMessageGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var userMessageGrid = this;
		setTimeout(function(){
			userMessageGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var userMessageGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Unsent'
							}, {
								code: 'I',
								desc: 'Sent'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					theme: 'primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					style: 'width: 2px; border: 1px solid lightgray;'
				},
				{
					tag: 'dl-action-button',
					theme: 'contrast primary',
					'class': 'spacer-toolbar-item',				
					permissions: ['ADMIN_MESSAGEQUEUE_MANAGEMENT:MANAGE_LIFECYCLE'],
					children:[
						ElementUtil.makeIcon('vaadin:bolt', ' Process Now')
					],
					listeners: {
						click: function() {							
							processNow();
						}
					}
				},				
				{
					tag: 'dl-action-button',	
					theme: 'contrast primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_MESSAGEQUEUE_MANAGEMENT:MANAGE_LIFECYCLE'],
					children:[
						ElementUtil.makeIcon('vaadin:warning', ' Cleanup Old Messages')
					],
					listeners: {
						click: function() {							
							cleanOldMessages();
						}
					}
				},								
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_MESSAGEQUEUE_MANAGEMENT:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});			
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [	
				{						
					path: 'username',
					header: 'User Name',					
					width: '7em'
				},				
				{						
					path: 'userMessageType',
					header: 'User Message Type',					
					width: '9em'
				},
				{						
					path: 'subject',
					header: 'Subject',						
					'flex-grow': '1'
				},
				{						
					path: 'alertId',
					header: 'Alert Id',					
					width: '7em'
				},	
				{						
					path: 'messageSendMethod',
					header: 'Send Method',					
					width: '7em'
				},					
				{						
					path: 'pendingAddresses',
					header: 'Pending Address(es)',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var addresses = rowData.item.pendingAddresses ? rowData.item.pendingAddresses : [];													
						root.innerHTML = addresses.join(', ');
					}
				},
				{						
					path: 'sentAddresses',
					header: 'Sent Address(es)',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var addresses = rowData.item.sentAddresses ? rowData.item.sentAddresses : [];													
						root.innerHTML = addresses.join(', ');					
					}
				},				
				{						
					path: 'updateDts',
					header: 'Update Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'view').disabled = false; 						
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;				
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					userMessageGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						userMessageGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					Service.getUserMessageService().getUserMessages(userMessageGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, userMessageGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getUserMessageService().exportUserMessages(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		userMessageGrid.append(flexLayout);				
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
				
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected message?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting message...');													
							
							Service.getUserMessageService().deleteMessage(record.userMessageId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted message', {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});			
		};
		
		var cleanOldMessages = function() {
			var loadMask = grid.showLoading('Removing Expired Sent Messages...');	
			Service.getUserMessageService().cleanupOldMessages().then(function(result){
				loadMask.remove();
				window.DL.MessageUtil.showToast('Success', result.data, {									
					theme: 'success'
				});
				actionRefresh();
			});			
		};
		
		var processNow = function() {
			var loadMask = grid.showLoading('Submitting Task...');	
			Service.getUserMessageService().processMessageNow().then(function(result){
				loadMask.remove();
				window.DL.MessageUtil.showToast('Success', result.data, {									
					theme: 'success'
				});
				actionRefresh();
			});
		};
		
		var actionView = function(record) {
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Message',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
							
							var formatAddresses = function(addresses, missingMessage) {
								var missingMessage = missingMessage || 'NA';
								if (addresses) {
									return addresses.join(', ');	
								} else {
									return missingMessage;
								}
							};
							
							var date = TimeUtil.parseDate(inputRecord.updateDts);						
							var formatedDate =  TimeUtil.formatDateStandard(date);
							var detailData = [
								{
									key: 'Create Date',
									value: TimeUtil.formatDateStandard(TimeUtil.parseDate(inputRecord.createDts))
								},
								{
									key: 'Update Date',
									value: formatedDate
								},
								{
									key: 'Active Status',
									value: inputRecord.activeStatus
								},
								{
									key: 'Intended User',
									value: inputRecord.username ? inputRecord.username : 'Not Available'
								},
								{
									key: 'Message Type',
									value: inputRecord.userMessageType
								},
								{
									key: 'Alert Id',
									value: inputRecord.alertId ? inputRecord.alertId : 'N/A'
								},
								{
									key: 'Urgency Level',
									value: inputRecord.urgencyLevel	? inputRecord.urgencyLevel : 'N/A'								
								},
								{
									key: 'Subject',
									value: inputRecord.subject
								},
								{
									key: 'Message',
									value: inputRecord.bodyOfMessage ? inputRecord.bodyOfMessage.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''
								},
								{
									key: 'Pending Address',
									value: formatAddresses(inputRecord.pendingAddresses, 'Sent')
								},
								{
									key: 'Sent address',
									value: formatAddresses(inputRecord.sentAddresses, 'Waiting to Send')
								},
								{
									key: 'Retry Count',
									value: inputRecord.retryCount
								},
								{
									key: 'Collate',
									value: inputRecord.collate ? inputRecord.collate : 'false'
								}
								
							];
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',									
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(userMessageGrid.fullDataSet);
											event.target.setSelectedRecord('userMessageId', record.userMessageId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));	
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));						
						
					}
				}
			});
		};
		
	}
	
};
customElements.define('dl-usermessage-grid', UserMessageGrid);

